<template>
  <div class="for-authors">
    <div class="page-title">For Authors</div>
    <!--Mobile Only-->
    <b-nav-item-dropdown is-nav class="nav mobile-page-menu hidden-md-up mb-2" :text="currentPage">
      <b-dropdown-item><router-link :to="{ name: 'forAuthorsSubmissionGuidelines' }" @click.native="currentPage='Submission Guidelines'">Submission Guidelines</router-link></b-dropdown-item>
      <b-dropdown-item><router-link :to="{ name: 'forAuthorsStyleGuidelines' }" @click.native="currentPage='Style Guidelines'">Style Guidelines</router-link></b-dropdown-item>
      <b-dropdown-item><router-link :to="{ name: 'forAuthorsPolicies' }" @click.native="currentPage='Policies'">Policies</router-link></b-dropdown-item>
    </b-nav-item-dropdown>
    <!--Mobile Only-->
    <!--Non-Mobile Only-->
    <div class="page-menu hidden-sm-down">
      <b-nav class="row tabs">
        <b-nav-item :to="{ name: 'forAuthorsSubmissionGuidelines' }">Submission Guidelines</b-nav-item>
        <b-nav-item :to="{ name: 'forAuthorsStyleGuidelines' }">Style Guidelines</b-nav-item>
        <b-nav-item :to="{ name: 'forAuthorsPolicies' }">Policies</b-nav-item>
      </b-nav>
    </div>
    <!--Non-Mobile Only-->
    <router-view></router-view>
  </div>

</template>

<script>
  import ForAuthorsPolicies from '@/components/for-authors/for-authors-policies/ForAuthorsPoliciesPage'
  export default {
    name: 'for-authors',
    components: {
      ForAuthorsPolicies
    },
    data () {
      return {
        currentPage: 'Submission Guidelines'
      }
    }
  }
</script>


<style lang="scss">
  .page-menu {
    .tabs {
      list-style: none;
      overflow: hidden;
      padding: 0;
      height: 36px;
      margin-bottom: 20px;
      position: relative;
      z-index: 1;
      margin-left: 0px;
      a {
        float: left;
        background: #eee;
        padding: 0 15px;
        text-decoration: none;
        height: 36px;
        text-align: center;
        border-left: 1px solid $white;
        line-height: 36px;
        border-bottom: 3px solid #eee;
        white-space: nowrap;
        cursor: pointer;
        &.active {
          border-bottom: 3px solid $secondary-color;
          cursor: default;
        }
      }
    }
  }

  .mobile-page-menu {
    background-color: $footer-background;

    a, a:active, a:hover {
      color: $secondary-color;
      outline: none;
      &.active {
        background-color: inherit;
      }
    }
  }

  .for-authors {
    h1 {
      color: $primary-color;
      font-family: 'Open Sans';
      padding-bottom: 20px;
    }
    section {
      &:before {
         display: block;
         content: "";
         height: 60px;
         margin: -60px 0 0;
       }
      .title {
        font-family: 'Merriweather';
        font-style: italic;
        font-size: 16px;
        font-weight: 600;
        color: $primary-color;
        marging: 15px 0;
        flex-direction: column;
        justify-content: center;
        display: flex;
      }
      padding-bottom: 20px;
      margin-bottom: 20px;
      border-bottom: 1px solid $grey-border;

    }


  }
</style>



// WEBPACK FOOTER //
// ForAuthorsPage.vue?33e8bdf3